module.exports = {
  key: "admin",
  attribute: {
    pay: "پرداخت",
    paid: "پرداخت شده",
    not_paid: "پرداخت نشده",
    New: "جدید",
    AddedCertificate: "اضافه شدن مدرک",
    Pending: "در انتظار",
    Ban: "بن",
    CancelByUser: "لغو توسط کاربر",
    FinalApproval: "تایید نهایی",
    FinalApprovalByUser: "تایید شده توسط کاربر",
    InitialApproval: "تایید اولیه",
    Done: "تکمیل شده",
    state: "وضعیت",
    payAmount: "مبلغ پرداختی",
    submission: "توضیحات",
    NotVerified: "غیرفعال",
    Active: "فعال",
    certificateFile: "تصویر مدرک",
    All: "همه",
    search: "جستجو",
    queryId: "ID",
    newest: "جدید ترین",
    oldest: "قدیمی ترین",
  },
  placeholder: {},
};
